export const DOTS = 'dots' as const;

export const DEFAULT_PAGE_SIZE_OPTIONS: readonly number[] = [10, 20, 30];

export const DEFAULT_SIBLING_COUNT = 1;

export const DEFAULT_BOUNDARY_COUNT = 1;
